import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import Icon from "../AppIcon";
import Button from "./Button";
import { useGlobalAuth } from "../../contexts/GlobalContext";
import { Link } from "react-router-dom";
import { useSupabaseUser } from '../../contexts/SupabaseUserContext';
import { signOut } from "../../api/SupabaseApi";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const userMenuRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { spotify, youtube } = useGlobalAuth();
  const isSpotifyLoggedIn = spotify.isLoggedIn;
  const isYouTubeLoggedIn = !!youtube.googleToken;
  const supabaseUser = useSupabaseUser();

  // const navigationItems = [
  //   { label: 'Dashboard', path: '/dashboard-sync-overview', icon: 'LayoutDashboard', tooltip: 'View sync overview and account status' },
  //   { label: 'New Sync', path: '/playlist-selection-sync-setup', icon: 'Plus', tooltip: 'Start a new playlist synchronization' },
  //   { label: 'History', path: '/sync-results-management', icon: 'History', tooltip: 'View completed sync results' },
  //   { label: 'Accounts', path: '/authentication-account-connection', icon: 'Users', tooltip: 'Manage platform connections' },
  // ];
  const navigationItems = [
    {
      label: "Home",
      path: "/",
      icon: "LayoutDashboard",
      tooltip: "View sync overview and account status",
    },
    {
      label: "Pricing",
      path: "/pricing",
      icon: "Tag",
      tooltip: "See our pricing plans",
    },
    // {
    //   label: "Dashboard",
    //   path: "/dashboard-sync-overview",
    //   icon: "LayoutDashboard",
    //   tooltip: "View sync overview and account status",
    // },

    // { label: 'New Sync', path: '/playlist-selection-sync-setup', icon: 'Plus', tooltip: 'Start a new playlist synchronization' },
    // { label: 'History', path: '/sync-results-management', icon: 'History', tooltip: 'View completed sync results' },
    // { label: 'Accounts', path: '/authentication-account-connection', icon: 'Users', tooltip: 'Manage platform connections' },
  ];

  const isActiveRoute = (path) => {
    return location.pathname === path;
  };

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleUserMenu = () => {
    setIsUserMenuOpen(!isUserMenuOpen);
  };

  useEffect(() => {
    if (!isUserMenuOpen) return;
    function handleClickOutside(event) {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target)) {
        setIsUserMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isUserMenuOpen]);

  return (
    <header className="fixed top-0 left-0 right-0 z-1000 bg-surface border-b border-border shadow-elevation-1">
      <div className="px-4 lg:px-6">
        <div className="flex items-center justify-between h-14 lg:h-16">
          {/* Logo and Brand */}
          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <Link
                to={"/"}
                className="flex items-center justify-center max-w-[160px] py-2"
              >
                <img src="./images/logo.png" alt="logo" />
              </Link>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            {navigationItems.map((item) => (
              <button
                key={item.path}
                onClick={() => handleNavigation(item.path)}
                className={`flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-smooth hover:bg-surface-secondary ${
                  isActiveRoute(item.path)
                    ? "text-primary bg-primary/10"
                    : "text-text-secondary hover:text-text-primary"
                }`}
                title={item.tooltip}
              >
                <Icon name={item.icon} size={18} />
                <span>{item.label}</span>
              </button>
            ))}
          </nav>

          {/* Account Status and User Menu */}
          <div className="flex items-center space-x-4">
            {/* Account Connection Indicators */}
            <div className="flex items-center space-x-2">
              <div
                className={`flex items-center space-x-1 px-2 py-1  rounded-full ${
                  isSpotifyLoggedIn ? "bg-success/10 " : "bg-error/10"
                }`}
              >
                <div
                  className={`w-2 h-2  rounded-full ${
                    isSpotifyLoggedIn ? "bg-success" : "bg-error"
                  }`}
                ></div>
                <span
                  className={`text-[10px] sm:text-xs font-medium ${
                    isSpotifyLoggedIn ? "text-success" : "text-error"
                  }`}
                >
                  Spotify
                </span>
              </div>
              <div
                className={`flex items-center space-x-1 px-2 py-1  rounded-full ${
                  isYouTubeLoggedIn ? "bg-success/10 " : "bg-error/10"
                }`}
              >
                <div
                  className={`w-2 h-2  rounded-full ${
                    isYouTubeLoggedIn ? "bg-success" : "bg-error"
                  }`}
                ></div>
                <span
                  className={`text-[10px] sm:text-xs font-medium ${
                    isYouTubeLoggedIn ? "text-success" : " text-error"
                  }`}
                >
                  YouTube
                </span>
              </div>
            </div>

            {/* Mobile Account Indicators */}
            {/* <div className="flex md:hidden items-center space-x-1">
              <div
                className={`w-2 h-2  rounded-full ${
                  isSpotifyLoggedIn ? "bg-success" : "bg-error"
                }`}
                title="Spotify Connected"
              ></div>
              <div
                className={`w-2 h-2  rounded-full ${
                  isYouTubeLoggedIn ? "bg-success" : "bg-error"
                }`}
                title="YouTube Disconnected"
              ></div>
            </div> */}

            {/* User Menu */}
            {supabaseUser ? (
              <div className="relative" ref={userMenuRef}>
                <button
                  onClick={toggleUserMenu}
                  className="flex items-center space-x-2 p-2 rounded-lg hover:bg-surface-secondary transition-smooth"
                >
                  <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                    <Icon
                      name="User"
                      size={16}
                      className="text-primary-foreground"
                    />
                  </div>
                  <Icon
                    name="ChevronDown"
                    size={16}
                    className="text-text-secondary hidden sm:block"
                  />
                </button>

                {isUserMenuOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-surface border border-border rounded-lg shadow-elevation-2 z-1010">
                    <div className="py-2">
                      <div className="px-4 py-2 border-b border-border">
                        <p className="text-sm font-medium text-text-primary">
                          {supabaseUser.user_metadata?.full_name ||
                            supabaseUser.email}
                        </p>
                        <p className="text-xs text-text-secondary overflow-ellipsis overflow-hidden w-fulll max-w-[200px]">
                          {supabaseUser.email}
                        </p>
                      </div>
                      <button 
                        className="w-full text-left px-4 py-2 text-sm text-text-secondary hover:text-text-primary hover:bg-surface-secondary transition-smooth"
                        onClick={() => navigate('/profile-settings')}
                      >
                        Settings
                      </button>
                      <button className="w-full text-left px-4 py-2 text-sm text-text-secondary hover:text-text-primary hover:bg-surface-secondary transition-smooth">
                        Help & Support
                      </button>
                      <hr className="my-1 border-border" />
                      <button
                        className="w-full text-left px-4 py-2 text-sm text-error hover:bg-error/10 transition-smooth"
                        onClick={signOut}
                      >
                        Sign Out
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <Button
                className="w-full text-left px-4 py-2 text-sm text-primary hover:text-primary hover:bg-surface-secondary transition-smooth"
                onClick={() => {
                  setIsUserMenuOpen(false);
                  navigate("/login");
                }}
              >
                Login
              </Button>
            )}

            {/* Mobile Menu Button */}
             <button
              onClick={toggleMobileMenu}
              className="lg:hidden p-2 !ml-0 rounded-lg hover:bg-surface-secondary transition-smooth"
            >
              <Icon
                name={isMobileMenuOpen ? "X" : "Menu"}
                size={20}
                className="text-text-primary"
              />
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden border-t border-border bg-surface">
            <nav className="py-4 space-y-2">
              {navigationItems.map((item) => (
                <button
                  key={item.path}
                  onClick={() => handleNavigation(item.path)}
                  className={`w-full flex items-center space-x-3 px-4 py-3 text-left rounded-lg transition-smooth ${
                    isActiveRoute(item.path)
                      ? "text-primary bg-primary/10"
                      : "text-text-secondary hover:text-text-primary hover:bg-surface-secondary"
                  }`}
                >
                  <Icon name={item.icon} size={20} />
                  <span className="font-medium">{item.label}</span>
                </button>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
